import { Box, Typography, List, ListItem } from "@mui/material";
import React from "react";
import data from "../../Assets/data/chaptersinbooks.json";

const ChaptersSection = React.forwardRef((props, ref) => {
  return (
    <>
      <Box ref={ref}>
        <Typography
          style={{ margin: "24px 0px 0px" }}
          fontSize="32px"
          fotnWeight={800}
        >
          Chapters in Books
        </Typography>
        <List>
          {data.map((chapter, i) => {
            return (
              <ListItem
                key={i}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Typography fontWeight={600} fontSize="18px">
                  {chapter.title}
                </Typography>
                <Typography>{chapter.author}</Typography>
                <Typography fontSize="14px">{chapter.year}</Typography>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </>
  );
});

export default ChaptersSection;
